var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27734 9.35547C8.66016 8.79297 9.98438 8.51172 11.25 8.51172C12.5156 8.51172 13.8281 8.79297 15.1875 9.35547C16.5703 9.89453 17.2617 10.6094 17.2617 11.5V13.0117H5.23828V11.5C5.23828 10.6094 5.91797 9.89453 7.27734 9.35547ZM4.5 5.48828H6.75V7H4.5V9.25H2.98828V7H0.738281V5.48828H2.98828V3.23828H4.5V5.48828ZM13.3594 6.12109C12.7734 6.70703 12.0703 7 11.25 7C10.4297 7 9.72656 6.70703 9.14062 6.12109C8.55469 5.53516 8.26172 4.83203 8.26172 4.01172C8.26172 3.19141 8.55469 2.48828 9.14062 1.90234C9.72656 1.29297 10.4297 0.988281 11.25 0.988281C12.0703 0.988281 12.7734 1.29297 13.3594 1.90234C13.9453 2.48828 14.2383 3.19141 14.2383 4.01172C14.2383 4.83203 13.9453 5.53516 13.3594 6.12109Z",
    fill: "#212121",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContact);
export default __webpack_public_path__ + "static/media/add_contact.147e2e38c4a1df463da37a124698b71e.svg";
export { ForwardRef as ReactComponent };